import React, { useEffect, useState } from "react";
import { Grid, Nav, NavItem } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "../../../../../context/global/state";
import SecondaryNavDropdown from "./secondaryNavDropdown";
import NoDemoLink from "components/controllers/shared/tooltip/noDemoLink";
import { convertUrl } from "./helpers/helpers";
import sass from "components/controllers/shared/styled/sass";

// Todo: Add sponsorHelp & guidedTour, refer to containers/templates/elements/menu/mainMenu.tsx
// Todo: add active nav sub items on current page, when react page

const SecondaryNav: React.FC = () => {
	const history = useHistory();
	const { data, nav, dispatch } = useGlobalContext();
	const siteContext = nav.getSiteContext(history);
	const [context, setContext] = useState(siteContext);
	const { charcoal } = sass.variables.color;

	const init = data[context]?.secondaryNavItems ?? [];
	const [items, setItems] = useState(init);

	useEffect(() => {
		const listener = history.listen((event) => {
			const siteContext = nav.getSiteContext(history);
			setContext(siteContext);
			const secondaryNavItems =
				data[siteContext]?.secondaryNavItems ?? [];
			setItems(secondaryNavItems);
		});
		return () => {
			listener();
		};
	}, [history, data, context, items, nav]);

	return (
		<section className="nav-secondary-wrapper util-margin-bottom-15 hidden-xs hidden-sm hidden-md">
			<Grid style={{ height: "45px" }}>
				<Nav
					className="nav-secondary js-product-nav util-inlineBlock"
					style={{ width: "100%" }}
				>
					{items.map((item, index) => {
						// react #/member/
						let url;
						if (item.url) {
							url = convertUrl(item);
						}

						const dropDownProps = {
							index,
							title: item.linkText,
							navigationTopic: item.navigationTopic,
						};

						const pathname = `#${history.location.pathname}`;
						const navItemIsActive = pathname === url;
						// Condition for active highlight with no dropdown (example: employer-nq/reports)
						const navExperience = url?.split("/")[2] ?? "nav";
						const pathExperience = pathname.split("/")[2] ?? "path";
						const experiencesMatch =
							navExperience === pathExperience;

						const isNoDemo = item.url === "#no-demo";
						const navItemActive =
							navItemIsActive || experiencesMatch ? "active" : "";

						return (
							<React.Fragment key={`${index}-nav-secondary-frag`}>
								{item.navigationTopic ? (
									<SecondaryNavDropdown
										role="presentation"
										{...dropDownProps}
									/>
								) : isNoDemo ? (
									<NavItem
										className={navItemActive}
										eventKey={index}
									>
										<NoDemoLink block={false}>
											<span style={{ color: charcoal }}>
												{item.linkText}
											</span>
										</NoDemoLink>
									</NavItem>
								) : (
									<NavItem
										className={navItemActive}
										eventKey={index}
										href={url}
									>
										{item.linkText}
									</NavItem>
								)}
							</React.Fragment>
						);
					})}
					{context.includes("employer") && (
						<NavItem
							eventKey={`employer-nq-plan-admin-guide`}
							className="pull-right"
						>
							<NoDemoLink>
								<div style={{ color: "rgb(0, 145, 218)" }}>
									<i className="fa fa-question-circle"></i>
									<span style={{ paddingLeft: "3px" }}>
										{context === "employer-nq"
											? "Plan Admin Guide"
											: "Help"}
									</span>
								</div>
							</NoDemoLink>
						</NavItem>
					)}
					{context === "member" && (
						<li className="pull-right">
							{history.location.pathname === "/member" && (
								<button
									className="btn btn-link util-padding-horz-10"
									onClick={() =>
										dispatch({
											type: "guidedTour",
											payload: true,
										})
									}
								>
									<i
										className="fa fa-question-circle"
										aria-hidden="true"
									></i>
									&nbsp;Guided tour
								</button>
							)}
							<NoDemoLink>
								<button className="btn btn-link util-padding-horz-10">
									<i
										className="fa fa-search"
										aria-hidden="true"
									></i>
									&nbsp;Search
								</button>
							</NoDemoLink>
						</li>
					)}
				</Nav>
			</Grid>
		</section>
	);
};

export default SecondaryNav;
